import { Box, Button, Colors } from '@altermaind/web/ui';

type Tab = {
  title: string;
  index: number;
  active: boolean;
  dataTestId?: string;
  backgroundColor?: keyof Colors;
};

type Props = {
  tabs: Tab[];
  setActiveTab: (index: number) => void;
  buttonVariant?: 'link/primary' | 'primary';
  backgroundColor?: keyof Colors;
};

export const Tabs = ({
  tabs,
  setActiveTab,
  buttonVariant = 'link/primary',
  backgroundColor = 'secondary/background',
}: Props) => {
  return (
    <Box
      width='fit-content'
      borderRadius='xl'
      display='flex'
      flexDirection='row'
      backgroundColor={backgroundColor}
    >
      {tabs.map(tab => {
        return (
          <>
            {tab.active && (
              <Button
                onClick={() => setActiveTab(tab.index)}
                variant={buttonVariant}
                fontSize='s'
                px='s'
                style={{ textDecoration: 'none' }}
                color='white'
                minWidth='unset'
                data-testid={tab?.dataTestId || undefined}
              >
                {tab.title}
              </Button>
            )}
            {!tab.active && (
              <Button
                onClick={() => setActiveTab(tab.index)}
                variant='link/primary'
                fontSize='s'
                px='s'
                style={{ textDecoration: 'none' }}
                color='primary/text'
                data-testid={tab?.dataTestId || undefined}
              >
                {tab.title}
              </Button>
            )}
          </>
        );
      })}
    </Box>
  );
};
